import script from "./VMultiText.vue?vue&type=script&setup=true&lang=js"
export * from "./VMultiText.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__